// 吹き出しメニュー内の選択肢1行（アイコン＋ラベル）。
// ソート軸・むき・フィルタ各項目で共通利用。横幅いっぱいなので長いラベルもはみ出さない。
// 「ひょうじ」Modal と同じ意匠：白地＋アクセント色ボーダー／選択時はアクセント色で塗りつぶし。
import I18n from "common/i18n";
import { usePlaySound } from "common/utils";

// activeBgClass → ボーダー色・アイコン色（ソース直書きの実クラス。Tailwind が確実に生成する）
const ACCENT_BY_BG: Record<string, { border: string; text: string }> = {
  "bg-green-100": { border: "border-green-100", text: "text-green-100" },
  "bg-blue-100": { border: "border-blue-100", text: "text-blue-100" },
  "bg-brown-80": { border: "border-brown-80", text: "text-brown-80" },
};

export const MenuOptionRow = ({
  icon,
  labelKey,
  active,
  activeBgClass,
  onClick,
}: {
  icon: string;
  labelKey: string;
  active: boolean;
  // 選択中の塗り色（例: "bg-green-100"）
  activeBgClass: string;
  onClick: () => void;
}) => {
  const play = usePlaySound();
  const accent = ACCENT_BY_BG[activeBgClass] ?? ACCENT_BY_BG["bg-green-100"];
  return (
    <button
      type="button"
      onClick={() => {
        play();
        onClick();
      }}
      className={`type-inherit-font flex-row-el items-center gap-2 w-full px-3 py-2 rounded-xl border-solid border-2 cursor-pointer ${
        active ? `${activeBgClass} ${accent.border}` : `bg-white ${accent.border}`
      }`}
    >
      <span
        className={`material-symbols-outlined type-md shrink-0 ${
          active ? "text-white" : accent.text
        }`}
      >
        {icon}
      </span>
      <p
        className={`type-text type-sm whitespace-nowrap flex-1 min-w-0 truncate !text-left ${
          active ? "text-white" : "text-textcolor-black"
        }`}
      >
        {I18n.t(labelKey)}
      </p>
    </button>
  );
};
